import { render, staticRenderFns } from "./BookingBtns.vue?vue&type=template&id=3229cf86&scoped=true"
import script from "./BookingBtns.vue?vue&type=script&lang=js"
export * from "./BookingBtns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3229cf86",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/vercel/path0/components/elements/Button.vue').default})
